import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Calculus integral sign (∫) — long S-curve with hooks at both ends.
 *  The two small filled dots at the upper-right and lower-left mark the
 *  upper / lower limits of integration, so the glyph reads
 *  unambiguously as a definite integral rather than a stylised "S". */
export function IcnIntegral(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="integral">
      <path d="M11 3 Q11 1.5 9 1.5 Q7 1.5 7 4.5 V11.5 Q7 14.5 5 14.5 Q3 14.5 3 13" />
      <circle cx="11.5" cy="3.5" r="0.7" fill="currentColor" stroke="none" />
      <circle cx="4.5" cy="12.5" r="0.7" fill="currentColor" stroke="none" />
    </Svg>
  );
}
